// React
import PropTypes from "prop-types";

// React Query
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

// API
import { getMakes } from "@/Common/api/vehicles";
import { getFormatVersionProducts, updateSpecialUnistRule } from "@/Motivators/api/specialUnits";

// Components
import SpecialUnitsModelCommissions from "@/Motivators/components/SpecialUnits/SpecialUnitsModelCommission/SpecialUnitsModelCommissions";

export default function SpecialUnitsModelCommissionsContainer(props) {
	const { specialUnitsListType, location: locationId, listId } = props;

	const queryClient = useQueryClient();

	const { data: makesList, isLoading: loadingMakes } = useQuery({
		queryKey: ["makes"],
		queryFn: async () => getMakes(),
		enabled: !!props.location,
		staleTime: Infinity,
	});

	const { data: versionProducts } = useQuery({
		queryKey: ["versionProducts", props.location],
		queryFn: async () => getFormatVersionProducts(props.location),
		staleTime: Infinity,
		enabled: !!props.location,
	});

	const { mutate: mutateRules, isPending: isPendingRules } = useMutation({
		mutationKey: ["updateSpecialUnitsRules", locationId, listId],
		mutationFn: (rules) =>
			updateSpecialUnistRule({
				listId,
				locationId,
				input: { rules },
				specialUnitsListType,
			}),
		onSuccess: (mutated) =>
			queryClient.setQueryData(["specialUnitsSetupEntry", locationId, listId], (old) => ({
				...old,
				...mutated,
			})),
	});

	return (
		<SpecialUnitsModelCommissions
			emptyMessage={"Please add one or more rules."}
			mainProductLabel={"Total Gross Profit"}
			commissions={props?.data || null}
			frontProducts={versionProducts?.frontProducts || []}
			backProducts={versionProducts?.backProducts || []}
			makes={makesList || []}
			loading={props?.loading || isPendingRules}
			loadingProducts={props.loadingProducts}
			loadingMakes={loadingMakes}
			readOnly={false}
			onActionUpdate={(model) => mutateRules(model)}
		/>
	);
}

SpecialUnitsModelCommissionsContainer.propTypes = {
	location: PropTypes.string,
	data: PropTypes.shape({
		new: PropTypes.shape({
			definitions: PropTypes.array,
			totalSpecialUnits: PropTypes.bool,
		}),
		preOwned: PropTypes.shape({
			definitions: PropTypes.array,
			totalSpecialUnits: PropTypes.bool,
		}),
		globalUnitCounts: PropTypes.bool,
	}),
	listId: PropTypes.string,
	loading: PropTypes.bool,
	loadingProducts: PropTypes.bool,
	specialUnitsListType: PropTypes.string,
};
